import _Number$parseInt from "@babel/runtime-corejs2/core-js/number/parse-int";
import _Number$isNaN from "@babel/runtime-corejs2/core-js/number/is-nan";
import tokens from "@paprika/tokens"; //
// Utilities
//

export var toInt = function toInt(token) {
  return _Number$parseInt(token, 10);
};
export var cssValue = function cssValue(value) {
  return _Number$isNaN(Number(value)) ? value : "".concat(value, "px");
}; //
// Typography
//

var fontScaleRatio = 1.125; // 8:9 - Major second

export var fontSizeValue = function fontSizeValue() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Math.round(_Number$parseInt(tokens.fontSize["default"], 10) * Math.pow(fontScaleRatio, scale));
};
export var fontSize = function fontSize() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n  font-size: ".concat(fontSizeValue(scale), "px;\n");
};
var leadingBase = 1.4;
var leadingScaleRatio = 1.125;
export var lineHeightValue = function lineHeightValue() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Math.round(leadingBase * Math.pow(leadingScaleRatio, scale) * 100) / 100;
};
export var lineHeight = function lineHeight() {
  var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n  line-height: ".concat(lineHeightValue(scale), ";\n");
}; //
// Layout
//

export var spacer = function spacer(numSpaces) {
  return "".concat(_Number$parseInt(tokens.space, 10) * numSpaces, "px");
};

function zIsValid(level) {
  return /^-1$|^[0-7]$|^inherit$|^initial$|^auto$/.test(level);
}

export var z = function z(level) {
  return zIsValid(level) ? "z-index: ".concat(level, ";") : "z-index: 1;";
};
export var zValue = function zValue(level) {
  return zIsValid(level) ? level : 1;
}; //
// Color
//

export function rgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return null;
  return [_Number$parseInt(result[1], 16), _Number$parseInt(result[2], 16), _Number$parseInt(result[3], 16)];
}
export function alpha(colorValue) {
  var alphaValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return "rgba(".concat(rgb(colorValue), ", ").concat(alphaValue, ")");
}
//# sourceMappingURL=helpers.js.map